/**
 * Build the authenticated proxy URL for an R2 object key.
 *
 * Keys can embed user-supplied filenames (uploaded reference and bank
 * images keep their original name in the key), so each path segment is
 * percent-encoded — a space, `#`, `?`, or `%` in a filename would
 * otherwise truncate or corrupt the request path and 404. The API's serve
 * route decodes the path before the R2 lookup.
 */
export function r2Url(r2Key: string): string {
  return `/api/r2/${r2Key.split('/').map(encodeURIComponent).join('/')}`;
}
